import React from 'react';
import clsx from 'clsx';
import { toTitleCase } from '../../../../../../../utils/utils';
import profileStyles from './UserProfile.module.scss';
import type { DirectorShip, Education, ListRowProps } from './ManagementUserProfile.types';

// Shared row for the Work Experience / Education / Other Directorships lists.
const ListRow = ({ icon, name, dateRange, pill, subline }: ListRowProps) => (
    <div className={profileStyles.DirectorShip}>
        <div className={profileStyles.DirectorShipMain}>
            {icon}
            <div className={profileStyles.DirectorShipText}>
                <div className={profileStyles.DirectorShipName}>{toTitleCase(name)}</div>
                {subline && <div className={profileStyles.DirectorShipSubline}>{subline}</div>}
            </div>
        </div>
        {pill ? (
            <div className={clsx({ [profileStyles.Active]: pill.active, [profileStyles.Former]: !pill.active })}>{pill.label}</div>
        ) : (
            <div className={profileStyles.Dates}>{dateRange}</div>
        )}
    </div>
);

export default ListRow;
